/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
    <br>
  <div>
  <div class="formPosition">
          <v-card style="margin:auto;" width="1000px">
            <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
          <v-card-title style="background-color:#006699;color:white;">Novo Comprovativo bancário</v-card-title>
 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>
                   <v-row>
                    <v-col cols="12" md="12">
                       <v-autocomplete
                        v-model="estudanteSelected"
                        :items="estudantes"
                        :loading="isLoading_"
                        :search-input.sync="search"
                        color="primary"
                        item-text="nome"
                        item-value="nome"
                        label="Nome do estudante"
                        placeholder="Digite o nome do estudante"
                        return-object
                        @change="AddEstudante()"
                       ></v-autocomplete>
                        <v-text-field v-if="!novo"
                          v-model="editedItem.nome"
                          :rules="ruleRequired"
                          :disabled="true"
                          label="Nome do estudante"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                     <v-col cols="12" md="10">
                         <v-progress-linear
                         v-if="progresso_pesquisa"
                        color="green accent-4"
                        indeterminate
                        rounded
                        height="6"
                      ></v-progress-linear>
                      <span style="color:red;" v-if="mensagem"  >O estudante não foi encontrado</span>
                     </v-col>
                  </v-row>
                   <v-row>
                     <v-col cols="12" md="6" v-if="estudantes_selecionados.length">
                         <v-list style="border:1px solid #c9bdbd;"
                       >
                        <v-list-item-group
                            color="indigo"
                        >
                          <v-list-item
                            v-for="i in estudantes_selecionados"
                            :key="i"
                          >
                            <v-list-item-icon>
                              <v-icon @click="remover(i)">delete</v-icon>
                           </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title  >{{i.nome}}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                     </v-col>
                      <v-col cols="12" :md="(estudantes_selecionados.length)?'6':'12'">
                        <v-text-field
                        :disabled="!estudantes_selecionados.length"
                        :rules="ruleRequired"
                        v-model="reciboComprovativo"
                         label="Nº do recibo/Comprovativo"
                       ></v-text-field>
                     </v-col>
                      <v-col cols="12" md="4">
                         <template>

                      <v-menu
                        ref="menuDataPagamento"
                        v-model="menuDataPagamento"
                        :close-on-content-click="false"
                        transition="scale-transition"
                         offset-y
                        full-width
                        min-width="290px"
                      >
                        <template  v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dataPagamentoSelected"
                            :rules="[v => !!v || 'Campo obrigatorio!']"
                            label="Data de Pagamento"
                            prepend-icon="event"
                            readonly
                            :disabled="!estudantes_selecionados.length"
                            v-on="on"
                          ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            :max="maxYear"
                            :min="minYear"
                            v-model="datePagamento"
                            @change="saveDatePagamento"
                          ></v-date-picker>
                        </v-menu>
                        </template>
                     </v-col>
                     <v-col cols="12" md="4">
                       <v-combobox
                          v-model="bancoSelected"
                          :rules="ruleRequired"
                          label="Selecione o banco"
                          item-value="pk_banco"
                          item-text="nome"
                          :disabled="disabilita"
                          :items="bancos"
                          @change="loadContaBancaria()"
                      ></v-combobox>
                     </v-col>
                      <v-col cols="12" md="4">
                       <v-combobox
                           v-model="contaSelected"
                          :rules="ruleRequired"
                          :items="contasFiltered"
                          :disabled="disabilita"
                          item-text="numeroConta"
                          label="Selecione a conta"
                      ></v-combobox>
                     </v-col>
                     <v-col cols="12" md="4">
                        <v-text-field
                          v-model="valor"
                           v-money="money"
                          :disabled="disabilita"
                          label="Valor depositado"
                       ></v-text-field>
                     </v-col>
                  </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn    :disabled="!valid && novo"  color="success"    @click="Guardar()">Guardar <v-icon>save_alt</v-icon></v-btn>
              </v-card-actions>

</v-form>

            </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    valor: '',
    formaPagamentoSelected: null,
    params_multa: [],
    novo: true,
    isLoading_: false,
    overlay: false,
    search: null,
    bancoSelected: null,
    contaSelected: null,
    reciboComprovativo: null,
    dataPagamentoSelected: null,
    datePagamento: null,
    menuDataPagamento: null,
    progresso: false,
    disabilita: false,
    maxYear: '',
    minYear: '',
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    progresso_pesquisa: false,
    preco: 0,
    cursoSelected: '',
    serivoSelected: '',
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    estudanteSelected: null,
    contas: [],
    recibos: [],
    contasFiltered: [],
    cursos: [],
    bancos: [],
    multas: [],
    estudantesComMultas: [],
    estudantes_selecionados: [],
    estudantes: [],
    isLoading: false,
    turmasAll: [],
    mascara: '#########-AA-###',
    turmasFiltered: [],
    estudantesWatcher: [],
    municipiosAll: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    precos: [],

    searchInDb: '',
    pesquisa: '',
    mensagem: false,
    servicos: [],
    servicosFiltered: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    valorFormatado: '',
    classesSelected: '',
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    classes:
    [
      { id: 1, descricao: '10ª Classe' },
      { id: 2, descricao: '11ª Classe' },
      { id: 3, descricao: '12ª Classe' },
      { id: 4, descricao: '13ª Classe' }
    ],
    formas_pagamento:
    [
      { id: 7, descricao: 'Depósito Bancário' },
    ],
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],

    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome do Estudante',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Nº do recibo/Comprovativo', value: 'recibo' },
      { text: 'data de pagamento', value: 'dataPagamento' },
      { text: 'Forma de pagamento', value: 'formaPagamento' },
      { text: 'Banco', value: 'banco' },
      { text: 'Conta Bancaria', value: 'conta' },
      { text: 'Valor', value: 'valor' },
      { text: 'Autor', value: 'autor' }
    ],

    msg: '',
    valorMulta: 0,
    progresso2: false,
    servicosPreco: [],
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {
      ano: 0,
      autor: '',
      data_recibo: '',
      estudante_pk_estudante: 0,
      forma_pagamento: '',
      mes_recibo: 0,
      nome: '',
      nome_banco: '',
      num_recibo: '',
      numero_conta: '',
      pk_conta_bancaria: 0,
      pk_recibo: 0,
      valor: 0
    }
  }),

  computed: {

    /* preco:function()
    {
        return  (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(preco))
    } */
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },

    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    menuDataPagamento (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    dialog (val) {
      val || this.close()
    },
    search (val) {
      // Items have already been loaded
    // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)
      if (val !== null  && val.length > 3) {
      // Items have already been requested
        if (!this.estudantes.filter(t => t.nome.includes(val)).length) {
          this.estudantes = []
        }
         return this.Pesquisar(val)
      }
    }
 

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeBanco()
    this.initializeConcaBanco()
    this.SetMaxYear()
    this.SetMinYear()
  },

  methods: {

   

    SetMaxYear () {
      this.maxYear = '2023' + '-12-01'
    },

    SetMinYear () {
      this.minYear = parseint(ls.get('anolectivo'))-1 + '-01-01'
    },

    

    loadContaBancaria () {
        this.contasFiltered = this.contas.filter(c => c.fkBanco === this.bancoSelected.pk_banco)
    },

    async initializeBanco () {
      try {
        this.isLoading = true
        this.bancos = await axios
          .get('/bancosFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    Fechar () {
      this.novo = false
      this.estudantes_selecionados = []
    },

    async initializeMultasExistentes () {
      try {
        this.isLoading = true
        this.multas = await axios
          .get('/ListarMultasExistentes')
          .then(res => res.data)
        console.log(this.multas)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    

    async Pesquisar (valor) {
      try {
        this.progresso_pesquisa = true
        this.isLoading_ = true
        this.estudantes = await axios
          .get('/PesquisaEstudanteRecibo/' + valor)
          .then(res => res.data)

        this.progresso_pesquisa = false
        this.isLoading_ = false
      } catch (error) {
        this.progresso_pesquisa = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    editar () {
      // this.bancoSelected = this.editedItem.nome
      // this.preco = this.editedItem.numero_conta
      this.novo = true
    },

    async initializeConcaBanco () {
      try {
        this.isLoading = true
        this.contas = await axios
          .get('/conta-bancariaFindAll-escola')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    remover (item) {
      let index = this.estudantes_selecionados.indexOf(item)
      this.estudantes_selecionados.splice(index, 1)
    },
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL

    loadTurmaComb () { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.classesSelected = ''
    },

    chamaDialogo () {
      this.dialog = true
    },

    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeRecibos () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.recibos = await axios
          .get('/recibosFindAll')
          .then(res => res.data)
        if (this.recibos.length) {
          this.editedItem = Object.assign({}, this.recibos[0])
        }

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    AddEstudante () {
      let obj = {nome:this.estudanteSelected.nome, matricula:this.estudanteSelected.idMatricula, pkPessoa:this.estudanteSelected.pkPessoa} // Adiciona o estudante selecionado na lista
      this.estudantes_selecionados.push(obj)
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    saveDatePagamento (datePagamento) {
      this.$refs.menuDataPagamento.save(datePagamento)
      this.dataPagamentoSelected = datePagamento
      //this.VerificaDataMulta()
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(datePagamento).toISOString().substr(0, 10)
    },
    
    async Guardar () {
      if (this.$refs.form.validate()) {
          try {
            this.overlay = true
            let params = {
                recibo_id: 0,
                estudantes: this.estudantes_selecionados,
                formaPagamento: 7,
                conta: this.contaSelected,
                valor: utilitarios.MoneyValueToInteger(this.valor),
                data_recibo: this.dataPagamentoSelected,
                autor: ls.get('nomeUsuario'),
                banco: this.bancoSelected,
                recibo: this.reciboComprovativo,
            }

            let result = await axios.post('ComprovativosInsertOrUpdate',params)
            if(result.data.affectedRows >= 1){
               utilitarios.showAlertMessage('success','Comprovativo registrado com sucesso');
               this.close()
            }else{
              utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.');
            }
          } catch (error) {
            this.overlay = false
            utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.');
          }finally{this.overlay = false}
      }
    },
 
     
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
